<template>
  <div style="position: relative;">
    <div v-if="dialogName == 'first'" style="position: absolute; right: 0px; top: 0px;z-index: 1">
      <el-button type="primary" size="small" v-if="
                tableData[0] &&
                tableData[0].apprStatus != 2 &&
                tableData[0].apprStatus != 3 &&
                tableData[0].apprStatus != 4
              " icon="el-icon-check" @click="doChildApproved(2)">通过</el-button>
      <el-button type="primary" size="small" v-if="
                tableData[0] &&
                tableData[0].apprStatus != 3 &&
                tableData[0].apprStatus != 2 &&
                tableData[0].apprStatus != 4
              " icon="el-icon-close" @click="openNewDialog(3, '拒绝原因')">拒绝</el-button>
      <el-button type="primary" size="small" v-if="
                tableData[0] &&
                tableData[0].apprStatus != 4 &&
                tableData[0].apprStatus != 3 &&
                tableData[0].apprStatus != 2
              " icon="el-icon-refresh-left" @click="openNewDialog(4, '退回原因')">退回</el-button>
      <el-button type="primary" size="small" v-if="
                tableData[0] &&
                tableData[0].apprStatus != 5 &&
                tableData[0].apprStatus != 3 &&
                tableData[0].apprStatus != 2 &&
                tableData[0].apprStatus != 4
              " icon="el-icon-time" @click="doChildApproved(5)">待定</el-button>
      <el-button type="primary" size="small" v-if="
                tableData[0] &&
                tableData[0].apprStatus != 2 &&
                tableData[0].apprStatus != 3 &&
                tableData[0].apprStatus != 4 &&
                !isReadOnly
              " icon="el-icon-suitcase" @click="getChildApprove(tableData[0].apprStatus, true, true)">保存</el-button>
      <el-button type="primary" size="small" icon="el-icon-back" @click="back">返回</el-button>
    </div>
    <el-tabs v-model="dialogName">
      <el-tab-pane label="患儿信息" name="first">
        <ChapterHead :title="'患儿编号：' + childDetail.childId" :level="1">
            <span style="margin-left: 20px" v-if="childDetail.existsSimilar" @click="similarVisible = true">
              <span style="align-items: center" >
                 <img src="/static/err-icon.png" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" alt="" />
                 <span style="display: inline-block;vertical-align: middle;color: #dc243e;cursor: pointer;text-decoration: underline">存在相似患儿</span>
              </span>
            </span>
          <span slot="extra">
            <img src="/static/status-icon.png" style="width: 15px;height: 15px;margin-right: 6px; vertical-align: middle;" alt="">
          <span style="vertical-align: middle;">{{ childDetail.apprStatus == 5 ? '审核中' : childDetail.apprStatusText }}</span>
          </span>
        </ChapterHead>
        <el-row>
          <el-col :md="3" class="avatar-view">
            <div class="demo-image__preview" style="margin-top: 2vw; min-width: 100px; min-height: 100px">
              <el-image v-if='childImg'
                style="width: 100px; height: 100px; border-radius:50%"
                :src="childImg ? childImg : '/static/default-avatar.png'"
                :preview-src-list="[childImg ? childImg : '/static/default-avatar.png']">
              </el-image>
            </div>
<!--            <el-avatar shape="circle" style="margin-top: 2vw;min-width:100px;min-height: 100px" size="large"-->
<!--              class="avatar" :src="childImg?childImg:'/static/default-avatar.png'"></el-avatar>-->
            <div style="width: 100%;text-align: left;margin-top: 10px;font-size: 14px;color: #606266;padding-left: 10px;"  v-if="labelsList.length>0">相关标签：</div>
            <div style="width: 100%;text-align: left;margin-top: 10px;font-size: 14px;color: #606266;"  v-else>相关标签：无</div>
            <el-card class="box-card" style="width: 100%;"  v-if="labelsList.length>0" :md="20">
              <el-tag size="mini" v-for="(item,index) in labelsList" :key="index" style="margin: 0 2px;" effect="dark"
                type="info">{{ item }}</el-tag>
            </el-card>
          </el-col>
          <el-col :md="21">
            <el-form ref="childForm" :inline="true" :model="childDetail" :rules="formRules">
              <el-row>
                <el-col :md="6">
                  <el-form-item label="患儿姓名" prop="childName">
                    <el-input type="text" size="small" :disabled="isReadOnly" v-model="childDetail.childName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="性别" prop="childName">
                    <el-radio-group v-model="childDetail.sex" :disabled="isReadOnly">
                      <el-radio :label="'1'">男</el-radio>
                      <el-radio :label="'0'">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="身份证" prop="hasIdNumber">
                    <el-radio-group v-model="childDetail.hasIdNumber" :disabled="isReadOnly">
                      <el-radio :label="1">有</el-radio>
                      <el-radio :label="0">无</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col v-if="childDetail.hasIdNumber == 1" :md="6">
                  <el-form-item label="身份证号" prop="idNumber">
                    <el-input v-if="isReadOnly" type="text" size="small" disabled :value="childDetail.idNumber || '-'" ></el-input>
                    <el-input v-else type="text" size="small" v-model="childDetail.idNumber" @change="idNumberChange"></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-else :md="6">
                  <el-form-item label="身份证号">
                    <el-input type="text" size="small" disabled value="-"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="6">
                  <el-form-item label="出生日期" prop="childName">
                    <el-date-picker v-model="childDetail.birthday" :disabled="isReadOnly || childDetail.hasIdNumber == 1" type="date" size="small"
                      value-format="timestamp" format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="民族" prop="nation">
                    <DictionarySelect v-model="childDetail.nation" tableType="ay" tableCode="C00002" :lazy="true"
                      :disabled="isReadOnly"></DictionarySelect>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="监护人电话" prop="guardPhone">
                    <el-input v-if="isReadOnly" type="text" size="small" disabled :value="childDetail.guardPhone || '-'" ></el-input>
                    <el-input v-else type="text" size="small" :disabled="isReadOnly" v-model="childDetail.guardPhone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="其他电话" prop="guardOtherPhone">
                    <el-input v-if="isReadOnly" type="text" size="small" disabled :value="childDetail.guardOtherPhone || '-'" ></el-input>
                    <el-input v-else type="text" size="small" :disabled="isReadOnly" v-model="childDetail.guardOtherPhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="12">
                  <el-form-item label="户口所在地" prop="childName">
                    <LocationCascader v-model="childDetail.location" :options="[{
                        value: childDetail.province,
                        label: childDetail.provinceText,
                        leaf: false,
                        children: [{
                          value: childDetail.city,
                          label: childDetail.cityText,
                          leaf: false,
                          valueParentId: childDetail.province,
                          children: [{
                            value: childDetail.county,
                            label: childDetail.countyText,
                            leaf: true,
                            valueParentId: childDetail.city
                          }]
                        }]
                      }]" :disabled="isReadOnly">
                    </LocationCascader>
                  </el-form-item>
                </el-col>
                <el-col :md="12">
                  <el-form-item label="详细地址" prop="fullAddr">
                    <el-input v-if="isReadOnly" type="text" size="small" disabled :value="childDetail.fullAddr || '-'" ></el-input>
                    <el-input v-else type="text" size="small" :disabled="isReadOnly" v-model="childDetail.fullAddr"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="12">
                  <el-form-item label="常住地址" prop="liveAddr">
                    <el-input v-if="isReadOnly" type="text" size="small" disabled :value="childDetail.liveAddr || '-'" ></el-input>
                    <el-input v-else type="text" size="small" :disabled="isReadOnly" v-model="childDetail.liveAddr"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="监护人微信号" prop="guardWechat">
                    <el-input v-if="isReadOnly" type="text" size="small" disabled :value="childDetail.guardWechat || '-'" ></el-input>
                    <el-input v-else type="text" size="small" :disabled="isReadOnly" v-model="childDetail.guardWechat"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="登录手机号" prop="loginAccount">
                    <el-input type="text" size="small" disabled :value="childDetail.loginAccount || '-'" ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="6">
                  <el-form-item label="支付宝姓名" prop="loginUserName">
                    <el-input v-if="childDetail.loginUserName" type="text" size="small" disabled  v-model="childDetail.loginUserName"></el-input>
                    <el-input v-else type="text" size="small" disabled value="-" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="支付宝身份证" prop="loginIdNumber">
                    <el-input v-if="childDetail.loginIdNumber" type="text" size="small" disabled  v-model="childDetail.loginIdNumber"></el-input>
                    <el-input v-else type="text" size="small" disabled value="-" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="支付宝账号" prop="loginUserId">
                    <el-input v-if="childDetail.loginUserId" type="text" size="small" disabled  v-model="childDetail.loginUserId"></el-input>
                    <el-input v-else type="text" size="small" disabled value="-" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="与患儿关系">
                    <el-input type="text" size="small" disabled  :value="childDetail.loginRelationText || '-'"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="6">
                  <el-form-item label="住院号" prop="inHospitalNoSet">
                    <el-input v-if="childDetail.inHospitalNoSet" type="text" size="small" disabled  v-model="childDetail.inHospitalNoSet"></el-input>
                    <el-input v-else type="text" size="small" disabled value="-" ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <div class="screen">
          <tableRedBox title="当前申请">
            <el-table :data="tableData" style="width: 100%;" :class="tableData && tableData.length > 1 ? '' : 'applyTable'">
              <el-table-column width="150" label="申请编号">
                <template slot-scope="scope">
                  <span class="link" @click="requsetDetail(scope.row)">{{
                    scope.row.outlayType == '2' ? scope.row.specialPatientId : scope.row.helpId
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="submitTime"  width="100" label="申请时间">
                <template slot-scope="scope">
                  {{ scope.row.submitTime ? parseTime(scope.row.submitTime, '{y}-{m}-{d}') : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="reqModeText"  width="80" label="申请方式"></el-table-column>
              <el-table-column prop="hospitalName" width="200"  label="救助医院">
                <template slot-scope="scope">
                  <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
                </template>
              </el-table-column>
              <el-table-column prop="birth" width="180" label="病种">
                <template slot-scope="scope">
                  <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
                </template>
              </el-table-column>
              <el-table-column prop="initialProjectName" width="100" label="所属项目">
                <template slot-scope="scope">
                  {{scope.row.belongProjectName || scope.row.initialProjectName}}
                </template>
              </el-table-column>
              <el-table-column prop="type" width="50" label="期次">
                <template v-slot="scope">
                  {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-'))}}
                </template>
              </el-table-column>
              <el-table-column width="50" label="特患">
                <template slot-scope="scope">
                  <span v-if="scope.row.isSpecialPatient">是</span>
                  <span v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column prop="apprStatusText" label="救助状态">
              </el-table-column>
              <el-table-column prop="apprTime" label="审核时间" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.apprStatus > 1">{{ scope.row.apprTime ? parseTime(scope.row.apprTime, '{y}-{m}-{d}') : '-' }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="费用编号" width="145">
                <template slot-scope="scope">
                  <span v-if="scope.row.outlayId" class="link" @click="outlayDetail(scope.row)">{{ scope.row.outlayId }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="helpAmount" label="金额" width="110" align="right">
                <template v-slot="scope">
                  {{ scope.row.helpAmount ? parseFloat(scope.row.helpAmount || 0).toFixed(2) : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="outlayStatusText" label="费用状态">
                <template v-slot="scope">
                  {{ scope.row.applyType == 1 && scope.row.outlayStatusText ? scope.row.outlayStatusText : "-" }}
                </template>
              </el-table-column>
              <el-table-column prop="protocolId" label="协议编号" width="180">
                <template slot-scope="scope">
                  <TableCellWordBreak v-if="scope.row.protocolId" :content="scope.row.protocolId">
                    <span class="link" @click="openProtocolInfo(scope.row)">{{scope.row.protocolId}}</span>
                  </TableCellWordBreak>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="protocolStatusText" label="协议状态">
                <template v-slot="scope">
                  {{ scope.row.protocolStatusText || "-" }}
                </template>
              </el-table-column>
            </el-table>
          </tableRedBox>
          <ChapterHead title="历史申请" :level="2"></ChapterHead>
          <div style="padding: 0px 12px;">
            <el-table :data="otherTableData" :class="otherTableData && otherTableData.length > 0 ? (otherTableData.length == 1 ? 'applyTable' : '') : 'applyTableOverFlow'" style="width: 100%;">
              <el-table-column width="150" label="申请编号">
                  <template slot-scope="scope">
                    <span class="link" @click="requsetDetail(scope.row)">{{
                      scope.row.outlayType == '2' ? scope.row.specialPatientId : scope.row.helpId
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="requestTime"  width="100" label="申请时间">
                  <template slot-scope="scope">
                    {{ scope.row.specialRequestTime ? parseTime(scope.row.specialRequestTime, '{y}-{m}-{d}') : parseTime(scope.row.submitTime, '{y}-{m}-{d}') }}
                  </template>
                </el-table-column>
                <el-table-column prop="reqModeText"  width="80" label="申请方式"></el-table-column>
                <el-table-column prop="hospitalName" min-width="200"  label="救助医院">
                  <template slot-scope="scope">
                    <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
                  </template>
                </el-table-column>
                <el-table-column prop="birth" min-width="180" label="病种">
                  <template slot-scope="scope">
                    <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
                  </template>
                </el-table-column>
                <el-table-column prop="initialProjectName" width="100" label="所属项目">
                  <template slot-scope="scope">
                    {{scope.row.belongProjectName || scope.row.belongProjectName}}
                  </template>
                </el-table-column>
                <el-table-column prop="type" width="50" label="期次">
                  <template v-slot="scope">
                    {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-'))}}
                  </template>
                </el-table-column>
                <el-table-column width="50" label="特患">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isSpecialPatient">是</span>
                    <span v-else>否</span>
                  </template>
                </el-table-column>
                <el-table-column prop="apprStatusText" label="救助状态">
                </el-table-column>
                <el-table-column prop="apprTime" label="审核时间" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.apprStatus > 1">{{ scope.row.apprTime ? parseTime(scope.row.apprTime, '{y}-{m}-{d}') : '-' }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
                <el-table-column width="145" label="费用编号">
                  <template slot-scope="scope">
                    <span v-if="scope.row.outlayId" class="link" @click="outlayDetail(scope.row)">{{ scope.row.outlayId }}</span>
                    <p v-else>-</p>
                  </template>
                </el-table-column>
                <el-table-column prop="helpAmount" label="金额" width="110" align="right">
                  <template v-slot="scope">
                    {{ scope.row.helpAmount ? parseFloat(scope.row.helpAmount || 0).toFixed(2) : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="outlayStatusText" label="费用状态">
                  <template v-slot="scope">
                    {{ scope.row.applyType == 1 && scope.row.outlayStatusText ? scope.row.outlayStatusText : "-" }}
                  </template>
                </el-table-column>
                <el-table-column prop="protocolId"  width="180" label="协议编号">
                  <template slot-scope="scope">
                    <TableCellWordBreak v-if="scope.row.protocolId" :content="scope.row.protocolId">
                      <span class="link" @click="openProtocolInfo(scope.row)">{{scope.row.protocolId}}</span>
                    </TableCellWordBreak>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="protocolStatusText" label="协议状态">
                  <template v-slot="scope">
                    {{ scope.row.protocolStatusText || "-" }}
                  </template>
                </el-table-column>
            </el-table>
            <div v-if="!otherTableData || otherTableData.length == 0" class="history-table-empty">暂无数据</div>
          </div>
        </div>
        <ChapterHead title="辅助信息" :level="1"></ChapterHead>
        <div class="screen">
          <el-form :inline="true">
            <el-row>
              <el-col :md="6">
                <el-form-item label="是否义诊患儿">
                  <el-radio-group v-model="childDetail.isFreeClinic" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="是否回访">
                  <el-radio-group v-model="childDetail.isVisit">
                    <el-radio :label="1" :disabled="true">是</el-radio>
                    <el-radio :label="0" :disabled="true">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="6">
                <el-form-item label="是否精准扶贫">
                  <el-radio-group v-model="childDetail.isExactRelief" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="贫困程度">
                  <DictionarySelect v-model="childDetail.poorLevel" tableCode="POOL_LEVEL" placeholder="请选择" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0"
                    :lazy="true"></DictionarySelect>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="贫困程度备注">
                  <el-input v-model="childDetail.poorLevelRemark" size="small" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="6">
                <el-form-item label="是否宣传患儿">
                  <el-radio-group v-model="childDetail.isSpread" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="宣传理由">
                  <el-input v-model="childDetail.spreadCause" size="small" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <ChapterHead title="备注信息" :level="1"></ChapterHead>
        <div class="screen">
          <el-form :inline="true">
            <el-row style="margin-bottom: 20px;">
              <el-col :md="12">
                <el-input type="textarea" v-model="childDetail.remark" rows="3" :disabled="[1, 5].indexOf(childDetail.apprStatus) < 0"></el-input>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>

      <el-tab-pane label="操作日志" name="third" style='margin-bottom:20px'>
        <el-table :data="logData" style="width: 100%" height='calc(100vh - 195px)'>
          <el-table-column prop="operModule" label="模块名称">
          </el-table-column>
          <el-table-column prop="operData" label="字段名称"> </el-table-column>
          <!-- <el-table-column prop="operTypeText" width="100" label="操作">
          </el-table-column> -->
          <el-table-column prop="oldValue" label="旧值">
          </el-table-column>
          <el-table-column prop="newValue" label="新值"> </el-table-column>
          <el-table-column prop="operUserText" label="操作人"> </el-table-column>
          <el-table-column prop="operTime" label="操作时间">
            <template slot-scope="scope">
              {{ scope.row.operTime ? parseTime(scope.row.operTime, '{y}-{m}-{d}  {h}:{i}') : '-' }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <msgDialog :showMsgIcon="true" :title="popupTitle"  width="450px" @close="closePopup" :visible.sync="newDialog">
      <el-form :model="dialogForm" :inline="true" :rules="rules" ref="ruleForm">
        <el-form-item prop="apprOpinion" >
          <el-input type="textarea" :rows="6" style="width: 400px" resize="none" placeholder="请输入"
                    v-model="dialogForm.apprOpinion">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" >
        <el-button @click="newDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childExistsDialog" append-to-body :close-on-click-modal="false">
      <span>
        患儿已存在，可在
        <span style="font-weight: bold">患儿管理-新增病种</span>
        后进行救助申请！
      </span>
      <span class="info" @click="toChildManageDetail">进入患儿详细信息页面>></span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="childExistsDialog = false">关闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childOtherHospitalExistsDialog" append-to-body
               :close-on-click-modal="false">
      <span style="font-weight: bold;font-size: 16px">患儿已在其他医院注册，请联系爱佑基金会管理人员。</span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button type="primary" @click="childOtherHospitalExistsDialog = false">关闭</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" width="30%" title="提示" :visible.sync="childBaseInfoExistsDialog" append-to-body
               :close-on-click-modal="false">
      <span style="font-weight: bold;font-size: 16px">患儿基本信息重复！<br>存在患儿基础信息重复患儿，是否确认审核通过。</span>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="childBaseInfoExistsDialog = false">取 消</el-button>
        <el-button type="primary" @click="childApprove">确 定</el-button>
      </div>
    </msgDialog>
    <msgDialog :showErrorIcon="true" title="提示"  width="450px" @close="confirmDialog = false" :visible.sync="confirmDialog">
      <span style="font-weight: bold;font-size: 16px">该患儿的救助申请，确定审核{{commitStatus==2?'通过':'待定'}}？</span>
      <div slot="footer" >
        <el-button @click="confirmDialog = false">取 消</el-button>
        <el-button type="primary" @click="yanzheng()">确 定</el-button>
      </div>
    </msgDialog>

    <HelpDetailDialog :visible.sync="detailJzDialog" :disabled="false" @close="detailJzDialog = false" :outlayId="outlayId"
      v-if="detailJzDialog" :helpData="chooseData"></HelpDetailDialog>
    <HelpDetailDialog :outlayId="outlayId" :visible.sync="detailTxDialog" :disabled="false" @close="detailTxDialog = false"
      v-if="detailTxDialog" :helpData="chooseData"></HelpDetailDialog>
    <CureOutlayDialog :visible="outlayDialogVisible" v-if="outlayDialogVisible" :rowData="outlayRowData" @close="outlayDialogVisible = false"></CureOutlayDialog>
    <existsSimilarTable  :dialogDetail="similarVisible" v-if="similarVisible" :childUid="childDetail.childUid" @close="similarVisible = false"></existsSimilarTable>
    <CheckOutlayDialog :dialogVisible="checkDialogVisible" v-if="checkDialogVisible" :recordId="outlayRowData.outlayId" :readOnly="true" @close="checkDialogVisible = false"></CheckOutlayDialog>
    <ProtocolInfoDialog :visible="protocolDialogVisible" v-if="protocolDialogVisible" :protocolId="outlayRowData.protocolId" @close="protocolDialogVisible = false"></ProtocolInfoDialog>
  </div>
</template>

<script>
  import {
    parseTime
  } from "@/util/common.js";
  import tableRedBox from "@/components/business/tableRedBox";
  import Pageination from "@/components/business/Pageination";
  import LocationCascader from "@/components/business/LocationCascader";
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  import DictionarySelect from "@/components/business/DictionarySelect"


  import {
    getChildabels,
    getHelpStagesDataByIdApi,
    getHelpStagesNoPageApi,
    getChildApproveApi,
    getFileListByIds,
    getSpecialChildApi,
    getOutlayListByCondNoPaging,
    getOperationDataListByCondNoPaging,
    checkChildExistsApi
  } from "@/util/api.js";
  import msgDialog from "@/components/business/msgDialog";
  import HelpDetailDialog from "../view/HelpDetailDialog.vue"
  import ChapterHead from "@/components/business/ChapterHead";
  import CureOutlayDialog from "@/pages/outlay/view/CureOutlayDialog";
  import CheckOutlayDialog from "@/pages/outlay/view/CheckOutlayDialog";
  import ProtocolInfoDialog from '@/pages/protocol/view/ProtocolInfoDialog'
  import existsSimilarTable from "./existsSimilarTable";
  export default {
    components: {
      Pageination,
      CheckOutlayDialog,
      tableRedBox,
      LocationCascader,
      TableCellWordBreak,
      existsSimilarTable,
      ChapterHead,
      msgDialog,
      ProtocolInfoDialog,
      CureOutlayDialog,
      DictionarySelect,
      HelpDetailDialog
    },
    data() {
      var idCard = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入身份证号"));
        } else {
          var p =
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if (!p.test(value)) {
            callback("身份证格式不正确");
          }
        }
        callback();
      };
      var phoneVt = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入手机号"));
        } else {
          var p = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
          if (!p.test(value)) {
            callback("手机号格式不正确");
          }
          callback();
        }
      };
      return {
        dialogName: "first",
        commitParam:{},
        commitStatus:0,
        rules: {
          apprOpinion: [{
            required: true,
            message: "请输入原因",
            trigger: "blur",
          }, ],
        },
        formRules: {
          nation: [{ required: true, message: "请选择患儿民族", trigger: "change" }],
          fullAddr: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
          liveAddr: [{ required: true, message: "请输入常住地址", trigger: "blur" }],
          childName: [{ required: true, message: "请输入患儿姓名", trigger: "blur" }],
          sex: [{ required: true, message: "请选择性别", trigger: "change" }],
          hasIdNumber: [{ required: true, message: "是否持有身份证", trigger: "change" }],
          idNumber: [{ required: true, message: "请输入身份证号", trigger: "blur" }, { validator: idCard, trigger: "blur" }],
          location: [{ required: true, message: "请选择户口所在地", trigger: "change" }],
          birthday: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
          guardPhone: [{ required: true, message: "请输入监护人联系电话", trigger: "blur" }],
          guardIdNumber: [{ required: true, message: "请输入监护人身份证号", trigger: "blur" }, { validator: idCard, trigger: "blur" }],
          guardWechat: [{ required: true, message: "请输入监护人微信号", trigger: "blur" }],
        },
        isReadOnly: true,
        tableData: [],
        otherTableData: [],
        isShow: this.dialogVisible,
        dialogImageUrl: "",
        dialogVisible: false,
        protocolDialogVisible: false,
        outlayDialogVisible: false,
        checkDialogVisible: false,
        outlayRowData: {},
        similarVisible:false,
        disabled: false,
        newDialog: false,
        confirmDialog:false,
        dialogForm: {
          apprOpinion: "",
        },
        fqDialog: false,
        fqForm: {},
        moneyInputDialog: false,
        agreeDialog: false,
        detailJzDialog: false,
        detailTxDialog: false,
        detailTsDialog: false,
        helpId: "",
        childUid: "",
        childDetail: {
          childId: ''
        },
        search: {
          searchCond: {
            helpId: null, //救助ID
            excludeHelpId: null,
            forApprOnly: 1,
            childUid: null,
          },
          orderBy: "",
          pageNO: "",
          pageSize: "",
        },
        popupTitle: "",
        status: "",
        childImg: "",
        outlayId: "",
        chooseData: "",
        labelsList: [],
        applyData: "",
        searchData: {
          "searchCond": {
            "childUid": "", //患儿唯一ID
          },
          "orderBy": "",
          "pageNO": 1,
          "pageSize": 10
        },
        especiallyData: [], //特患数据
        especiallyTotal: 0,
        logData: [], //日志数据
        helpReqId: '',
        queryOutlayId: null,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        poolLevelDict: [], //贫困程度
        childExistsDialog: false,
        childOtherHospitalExistsDialog: false,
        childBaseInfoExistsDialog: false,
        exitsParams:''
      };
    },
    created() {
      this.helpId = this.$route.query.helpId;
      this.childUid = this.$route.query.childUid;
      this.helpReqId = this.$route.query.helpReqId;
      this.queryOutlayId = this.$route.query.outlayId;
      this.getHelpStagesDataById();
      this.getHelpStagesNoPage(this.helpId);
      this.getHelpStagesNoPage();
      this.getSpecialChild()
      this.operationDataListByCondNoPaging()
    },
    methods: {
      idNumberChange () {
        if (this.childDetail.idNumber && this.childDetail.idNumber.length > 14) {
          let year = this.childDetail.idNumber.substring(6, 10);
          let month = this.childDetail.idNumber.substring(10, 12);
          let day = this.childDetail.idNumber.substring(12, 14);
          this.$set(this.childDetail, 'birthday', new Date(year, parseInt(month) - 1, day));
        }
      },
      // 获取特患申请记录
      getSpecialChild() {
        this.searchData.searchCond.childUid = this.childUid
        getSpecialChildApi(this.searchData)
          .then((res) => {
            if (res.msgCode == 200) {
              this.especiallyData = res.responseData.modelData
              this.especiallyTotal = res.responseData.total
            }
          })
          .catch();
      },
      getChildabels(id) {
        getChildabels({
          childUid: id
        }).then(res => {
          if (res.msgCode == 200) {
              this.labelsList = res.responseData
              // 特殊患儿不显示 zh-20211101
              // this.labelsList=this.labelsList.filter(i=>i!='特殊患儿');
          }
        })
      },
      // 特患分页
      currentEspecially(e) {
        this.searchData.pageNO = e
        this.getSpecialChild()
      },

      // 特患改变总页
      sizeEspecially(e) {
        this.searchData.pageSize = e
        this.getSpecialChild()
      },

      // 获取操作日志不分页
      operationDataListByCondNoPaging() {
        let params = {
          "searchCond": {
            "helpReqId": this.helpReqId
          },
          orderBy: "operTime desc",
        }
        getOperationDataListByCondNoPaging(params).then((res) => {
            if (res.msgCode == 200) {
              this.logData = res.responseData.modelData
            }
          })
          .catch();
      },

      // 患儿详情
      requsetDetail(obj) {
        this.chooseHelpId = obj.helpId;
        this.outlayId = obj.outlayId;
        this.chooseData = obj;
        if (obj.reqMode == 1) {
          this.detailJzDialog = true;
        } else {
          this.detailTxDialog = true;
        }
      },
      // 特殊患儿详情
      specialDetail(obj) {
        this.chooseHelpId = obj.helpId
        this.outlayId = obj.outlayId
        this.chooseData = obj
        this.detailJzDialog = true;
      },
      // 关闭弹窗回调
      closePopup() {
        this.newDialog = false
        this.dialogForm.apprOpinion = null;
      },
      // 审核
      submit() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.newDialog = false;
            this.getChildApprove(this.status, true);
          }
        });
      },

      doChildApproved (status) {
        this.$refs.childForm.validate((valid) => {
          if (valid) {
            if(this.childDetail.hasIdNumber==1){
              if (this.childDetail.idNumber && this.childDetail.idNumber.length < 18) {
                this.$message.error('身份证格式不正确');
                return false;
              } else if (this.childDetail.idNumber && this.childDetail.idNumber.substring(6, 14) != this.parseTime(this.childDetail.birthday, '{y}{m}{d}')) {
                this.$message.error('出生日期与身份证号码中的日期不符');
                return false;
              }
            }
            this.getChildApprove(status, false);
          }
        });
      },

      // 审核患儿
      getChildApprove(status, type, stop) {
        var params = {
          childName: this.childDetail.childName || null,
          fullAddr: this.childDetail.fullAddr || null,
          liveAddr: this.childDetail.liveAddr || null,
          sex: this.childDetail.sex || null,
          hasIdNumber: (this.childDetail.hasIdNumber === 0 ) ? 0 : this.childDetail.hasIdNumber || null,
          idNumber: this.childDetail.idNumber || null,
          birthday: this.childDetail.birthday || null,
          guardPhone: this.childDetail.guardPhone || null,
          guardOtherPhone: this.childDetail.guardOtherPhone || null,
          guardWechat: this.childDetail.guardWechat || null,
          province: this.childDetail.location[0],
          city: this.childDetail.location[1],
          county: this.childDetail.location[2],
          nation: this.childDetail.nation,

          helpId: this.helpId, //救助ID
          apprStatus: status, //审核状态
          remark: this.childDetail.remark || null,
          apprOpinion: this.dialogForm.apprOpinion ? this.dialogForm.apprOpinion : null, //审核意见
          "isFreeClinic": this.childDetail.isFreeClinic, //是否义诊患儿
          "isSpread": this.childDetail.isSpread, //是否宣传患儿
          "spreadCause": this.childDetail.spreadCause || null, //宣传理由
          "isExactRelief": this.childDetail.isExactRelief, //是否精准扶贫
          "poorLevel": this.childDetail.poorLevel || null, //贫困程度
          "poorLevelRemark": this.childDetail.poorLevelRemark || null, //贫困程度备注
        };
        if(params.hasIdNumber == 0){
          params.idNumber=''
        }
        this.exitsParams = params
        if (type) {
          this.childApprove(params, stop);
        } else {
          this.confirmDialog = true
          this.commitParam = params
          this.commitStatus = status
        }
      },
      //验证,
      yanzheng(){
        this.checkChildExists(this.commitParam, () => {
          this.childApprove();
        });
        this.confirmDialog = false
      },
      //审核请求
      childApprove(params, stop) {
        getChildApproveApi(this.exitsParams)
          .then((res) => {
            if (res.msgCode == 200) {
              this.$message.success(stop ? '保存成功' : res.msg);
              if (!stop) {
                this.back();
              }
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((e) => {});
      },

      // 获取救助信息
      getHelpStagesNoPage(helpId) {
        if (helpId) {
          this.search.searchCond.helpId = helpId;
          this.search.searchCond.excludeHelpId = null;
          this.search.searchCond.childUid = this.childUid;
          this.search.searchCond.outlayId = this.queryOutlayId;
        } else {
          this.search.searchCond.helpId = null;
          this.search.searchCond.excludeHelpId = this.queryOutlayId ? null : this.helpId;
          this.search.searchCond.excludeOutlayId = this.queryOutlayId;
          this.search.searchCond.childUid = this.childUid;
          this.search.searchCond.outlayId = null;
        }
        getOutlayListByCondNoPaging(this.search)
          .then((res) => {
            if (res.msgCode == 200) {
              if (helpId) this.tableData = res.responseData.modelData;
              if (!helpId) this.otherTableData = res.responseData.modelData;
              // this.loading = false;
            } else {
              this.$message.error();
            }
          })
          .catch();
      },
      // 获取详情
      getHelpStagesDataById() {
        let params = {
          helpId: this.helpId,
        };
        getHelpStagesDataByIdApi(params)
          .then((res) => {
            if (res.msgCode == 200) {
              this.childDetail = res.responseData;
              this.childDetail.location = [res.responseData.province, res.responseData.city, res.responseData.county];
              this.isReadOnly = [1, 5].indexOf(this.childDetail.apprStatus) < 0 || this.childDetail.curStages != 1;
              this.getChildabels(this.childDetail.childUid)
              this.childDetail.birthdayText = parseTime(
                this.childDetail.birthday,
                "{y}-{m}-{d}"
              );
              this.downLoadFile(this.childDetail.portrait);
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch();
      },
      // 下载附件
      downLoadFile(id) {
        if (!id) {
           this.childImg ='/static/default-avatar.png'
          return false;
        }
        getFileListByIds([id])
          .then((res) => {
            if (res.msgCode == 200) {
              this.childImg = res.responseData[0].fileUrl;
            }
          })
          .catch();
      },
      // 返回
      back() {
        this.$router.push({ path: this.$route.meta.path + '?q=' + new Date().getTime() })
      },

      openNewDialog(status, title) {
        this.status = status;
        this.newDialog = true;
        this.popupTitle = title;
      },
      openFqDialog() {
        this.fqDialog = true;
      },
      openMoneyInputDialog() {
        this.moneyInputDialog = true;
      },
      outlayDetail (row) {
        this.outlayRowData = row;
        if (row.outlayType == '1') {
          this.outlayDialogVisible = true;
        } else {
          this.checkDialogVisible = true;
        }
      },
      openProtocolInfo (row) {
        this.outlayRowData = row;
        this.protocolDialogVisible = true;
      },
      checkChildExists(params, callback) {
        const param = JSON.parse(JSON.stringify(this.exitsParams))
        param.childUid = this.childUid
        checkChildExistsApi(param).then(res => {
          // this.loading = false;
          if (res.msgCode == 200) {
            if (res.responseData.childExistsCode == 0 || res.responseData.childExistsCode == 4) {
              callback();
            } else if (res.responseData.childExistsCode == 1) {
              this.childExistsDialog = true;
              this.lastHelpId = res.responseData.lastHelpId;
            } else if (res.responseData.childExistsCode == 2) {
              this.childOtherHospitalExistsDialog = true;
            } else if (res.responseData.childExistsCode == 3) {
              this.childBaseInfoExistsDialog = true;
            }
          } else {
            this.$message.error(res.msg)
          }
        });
      },
      toChildManageDetail() {
        this.childExistsDialog = false;
        this.$emit('back');
        this.$router.push({
          path: '/child/Detail',
          query: {
            helpId: this.lastHelpId
          }
        })
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "src/common/common";
  @import "src/common/form";

  .screen-view {
    width: 100%;
    display: flex;

    .screen-left {
      display: flex;
      width: 12vw;
      flex-direction: column;
      flex-shrink: 1;
      align-items: center;

      .child-head {
        width: 7vw;
        height: 7vw;
        border-radius: 50%;
        margin: 1.5vw 2vw 1.5vw 2vw;
        background-color: #666666;
      }

      .child-tips {
        background-color: #f1f1f1;
        width: 10vw;
        padding: 0.5vw 0.28vw;
        border-radius: 0.2vw;
        display: flex;
        flex-direction: column;

        .child-tips-title {
          font-size: 12px;
        }

        .child-tips-list {
          margin-top: 0.5vw;
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          .child-tip {
            font-size: 0.5vw;
            padding: 0.2vw;
            background-color: #d0d0d0;
            margin: 0.1vw 0.2vw;
            border-radius: 3vw;
          }
        }
      }
    }

    .screen-right {
      width: calc(100% - 20vw);
      margin-left: 1vw;
      height: auto;
    }
  }
  /deep/.el-table{
    .el-table__cell {
      padding: 8px 0 !important;
      .cell {
        height: 23px !important;
      }
    }
  }
  /deep/ .applyTable .el-table__body .el-table__row {
    height: 70px;
  }
  /deep/ .applyTableOverFlow .el-table__body-wrapper {
    // overflow-x: hidden;
    display: none;
  }
  .history-table-empty {
    font-size: 14px;
    width: 100%;
    text-align: center;
    line-height: 60px;
    color: #909399;
    border-bottom: 1px solid #EBEEF5;
  }
  .info {
    width: 100%;
    color: #E8556F;
    text-align: center;
    display: block;
    margin-top: 20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/child/audit/childShDetail.vue